export default "__VITE_ASSET__gtAFkTHc__"